import { MoonIcon } from './Icon'
import { heroPlaceholder } from '../assets/hero/placeholder'
import hero436avif from '../assets/hero/hero-436.avif'
import hero744avif from '../assets/hero/hero-744.avif'
import hero1086avif from '../assets/hero/hero-1086.avif'
import hero436webp from '../assets/hero/hero-436.webp'
import hero744webp from '../assets/hero/hero-744.webp'
import hero1086webp from '../assets/hero/hero-1086.webp'
import hero436jpg from '../assets/hero/hero-436.jpg'
import hero744jpg from '../assets/hero/hero-744.jpg'
import hero1086jpg from '../assets/hero/hero-1086.jpg'
import s from './HeroVisual.module.css'

const srcset = (a: string, b: string, c: string) => `${a} 436w, ${b} 744w, ${c} 1086w`

// Rendered width at each breakpoint. Browsers multiply by DPR to pick a
// candidate, so a 2× phone at 290px lands on the 744 file.
const SIZES = '(min-width: 900px) 372px, 290px'

export function HeroVisual() {
  return (
    <div className={s.visual}>
      <div className={s.photo} style={{ backgroundImage: `url(${heroPlaceholder})` }}>
        <picture>
          <source type="image/avif" srcSet={srcset(hero436avif, hero744avif, hero1086avif)} sizes={SIZES} />
          <source type="image/webp" srcSet={srcset(hero436webp, hero744webp, hero1086webp)} sizes={SIZES} />
          <img
            className={s.image}
            src={hero744jpg}
            srcSet={srcset(hero436jpg, hero744jpg, hero1086jpg)}
            sizes={SIZES}
            width={1086}
            height={1448}
            alt="A parent holding a newborn, with Tiny Boss log entries alongside"
            fetchPriority="high"
            decoding="async"
          />
        </picture>
      </div>

      {/* Decorative sample of a log entry — not real data. */}
      <div className={s.card}>
        <div className={s.cardEyebrow}>Just logged</div>
        <div className={s.cardRow}>
          <span className={s.cardTile}>
            <MoonIcon size={26} />
          </span>
          <div className={s.cardBody}>
            <div className={s.cardTitle}>Sleep · 1h 20m</div>
            <div className={s.cardMeta}>Dad · 6 min ago</div>
          </div>
        </div>
      </div>
    </div>
  )
}
